
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'V2FeatureSectionHeader',
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: 'vanilla-400'
    }
  }
})
